module.exports = __webpack_public_path__ + "img/logos_customer_04.f1cd95a7.svg";